import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'App'
import { replaceTerm } from 'utils/helper'
import { BoAdvisorWrapper } from 'components/Calendar/style'
import Button from 'components/Common/Button'
const ZENDESK_CHAT_URL = process.env.REACT_APP_ZENDESK_CHAT_URL

export default function NoAssignedAdvisorsStep() {
  const bsoProfile = useSelector((state: RootState) => state.bso.bsoProfile)
  const term = replaceTerm('advisor', bsoProfile.terminology)?.toLowerCase()
  const startsWithVowelSound = /^[aeiou]/.test(term)

  const advisorTerm = `${startsWithVowelSound ? 'an' : 'a'} ${term}`
  return (
    <BoAdvisorWrapper>
      <div className="h-full flex flex-col items-center p-10">
        <p className="mt-2">
          You are not matched to {advisorTerm} yet. Please contact GoTackle so we can get you
          connected.
        </p>
        <Button
          className="mt-8"
          variant="primary"
          label="Contact GoTackle"
          onClick={() => {
            window.open(ZENDESK_CHAT_URL, '_blank')
          }}
        />
      </div>
    </BoAdvisorWrapper>
  )
}
